import React from 'react';
import { __ } from '@wordpress/i18n';

// tools
import { getInstrumentIcon } from '../../instrumentIcons';

/**
 * Cue tag: instrument icon + cue number. Clicking it jumps to the cue —
 * what "jumps to" means depends on where the sidebar is mounted (see
 * `cueTarget` on CommCenterProvider).
 */
const CueTag = ({ code, instrument, onClick }) => {
    const Icon = getInstrumentIcon(instrument);

    return (
        <button
            type="button"
            className="cueTag"
            onClick={onClick}
            title={__('Apri la cue %s', 'soundbetween').replace('%s', code)}>
            <span className="cueTag__icon"><Icon/></span>
            <span className="cueTag__code">{code}</span>
        </button>
    )
}

export default CueTag;
